export const wastes: TableModule = {
    name: "wastes",
    route: "spa.projects.organisations.projects.wastes",
    defaultOrder: {
        column: "created_at",
        direction: "desc",
    },
    routeParams: [
        {
            param: "organisation",
            prop: "organisation_id",
        },
        {
            param: "project",
            prop: "project_id",
        },
    ],
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: "article_number",
            sortable: true,
            mobile: true,
        },
        {
            name: "waste_category_name",
            sortable: false,
        },
        {
            name: "contractor_name",
            sortable: false,
        },
        {
            name: "created_at",
            sortable: true,
        },
    ],
    filters: [
        {
            name: "id",
            column: "wastes.id",
            type: "numeric",
        },
    ],
    quickFilters: [],
    tools: [
        {
            name: "wastes.create",
            isCreateAction: true,
            ability: ["create", "wastes"],
        },
    ],
}
